<template>
  <form ref="form" action="./" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <input type="hidden" name="test_type" :value="abtest.abtest_type" />
    <div class="l-page l-page--abtest-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <h2 class="c-title__text c-title__text--blue u-fs34">配信メッセージの新規作成</h2>
            <div class="c-text">【曜日・時間帯比較のA/Bテスト】</div>
          </div>
          <div class="c-progress c-progress--abtest-demogra">
            <ul class="c-progress-list">
              <li class="c-progress-list__item">メッセージの作成</li>
              <li class="c-progress-list__item is-current">配信時間の<br />A/B設定</li>
              <!-- <li class="c-progress-list__item">配信条件の<br>設定</li> -->
              <li class="c-progress-list__item">配信内容の<br />確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <abtest-info :abtest="abtest" />
        </div>
        <div class="l-main-content l-main-content--select-timezone">
          <h3 class="c-title">
            <div class="c-title__text u-fs22">メッセージの動作・日程を設定する</div>
          </h3>
          <div class="p-abtest-edit-select-timezone">
            <div class="p-message-edit p-message-edit--message-action">
              <div class="p-message-edit-list">
                <div class="p-message-edit-list__item">
                  <div class="c-radio">
                    <div class="c-radio__title">通知動作を設定する</div>
                    <ul class="c-radio-list">
                      <li class="c-radio-list__item u-w100p">
                        <label class="c-radio__label">
                          <input
                            v-model="requireInteraction"
                            type="radio"
                            name="push_action"
                            value="0"
                          />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">一定時間後に自動最小化</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input
                            v-model="requireInteraction"
                            type="radio"
                            name="push_action"
                            value="1"
                          />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">ユーザーがアクションを起こすまで表示</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                    <div class="c-error">
                      <div class="c-error__text"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-text c-text--delivery-date">配信する日程のA/Bテストを設定する</div>
            <div class="p-abtest-edit-select-timezone__content">
              <h4 class="c-title c-title--pattern" data-text="A">
                <div class="c-title__text u-fs16">Aパターンの配信する日程
                  <span v-if="disableDateTimePicker" style="font-size: 14px; color: red;">配信済みのため変更できません</span>
                </div>
              </h4>
              <div class="p-message-edit-list__item p-message-edit-list__item--set-delivery-action">
                <div class="c-input u-w220">
                  <datepicker
                    ref="refSendStartDateA"
                    v-model="sendStartDateA"
                    name="delivery_date_a"
                    format="yyyy/MM/dd"
                    placeholder="YYYY/MM/DD"
                    input-class="c-input__item c-input__item--overlay-ico"
                    calendar-class="datepicker_calendar"
                    :language="ja"
                    :highlighted="highlightedDates"
                    :disabled="disableDateTimePicker"
                  />
                  <div class="c-input__icon c-input__icon--overlay"  :class="{ 'default-cursol' : disableDateTimePicker }" @click="showCalendar('delivery_date_a')">
                    <div class="c-icon c-icon--white u-wh22">
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use xlink:href="/assets/img/sprite.svg#calendar" />
                      </svg>
                    </div>
                  </div>
                  <input type="hidden" name="send_start_date_a" />
                  <div class="c-error c-error--balloon c-error--date">
                    <div class="c-error__text"></div>
                  </div>
                </div>
                <div class="c-select-time u-w220">
                  <timepicker
                    ref="timeSelect"
                    format="HH:mm"
                    hour-label="時"
                    minute-label="分"
                    name="delivery_hour_a"
                    placeholder="時間設定"
                    advanced-keyboard
                    manual-input
                    auto-scroll
                    :model-value="sendStartTimeA"
                    :disabled="disableDateTimePicker"
                    @update:model-value="onTimeSelectA"
                    @change="onTimeSelectA"
                    @blur="onTimeSelectA"
                  />
                  <div class="c-error c-error--balloon c-error--time">
                    <div class="c-error__text"></div>
                  </div>
                </div>
                <!-- <select-text
                                :value="messageA.message_deliver.deliver_type == 1 ? messageA.message_deliver.send_start_date.substring(11,16) : ''"
                                    ref="timeSelect"
                                    :classes="['u-w220']"
                                    place-holder="時間設定"
                                    :elements="times"
                                    @select="onTimeSelectA"
                                    input-name="delivery_hour_a"
                                >
                                </select-text> -->
              </div>
            </div>
            <div class="p-abtest-edit-select-timezone__content">
              <h4 class="c-title c-title--pattern" data-text="B">
                <div class="c-title__text u-fs16">Bパターンの配信する日程</div>
              </h4>
              <div class="p-message-edit-list__item p-message-edit-list__item--set-delivery-action">
                <div class="c-input u-w220">
                  <datepicker
                    ref="refSendStartDateB"
                    v-model="sendStartDateB"
                    name="delivery_date_b"
                    format="yyyy/MM/dd"
                    placeholder="YYYY/MM/DD"
                    input-class="c-input__item c-input__item--overlay-ico"
                    calendar-class="datepicker_calendar"
                    :language="ja"
                    :highlighted="highlightedDates"
                  />
                  <div class="c-input__icon c-input__icon--overlay" @click="showCalendar('delivery_date_b')">
                    <div class="c-icon c-icon--white u-wh22">
                      <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <use xlink:href="/assets/img/sprite.svg#calendar" />
                      </svg>
                    </div>
                  </div>
                  <input type="hidden" name="send_start_date_b" />
                  <div class="c-error c-error--balloon c-error--date">
                    <div class="c-error__text"></div>
                  </div>
                </div>
                <div class="c-select-time u-w220">
                  <timepicker
                    ref="timeSelect"
                    v-model="sendStartTimeB"
                    format="HH:mm"
                    hour-label="時"
                    minute-label="分"
                    name="delivery_hour_b"
                    placeholder="時間設定"
                    advanced-keyboard
                    manual-input
                    auto-scroll
                    :model-value="sendStartTimeB"
                    @update:model-value="onTimeSelectB"
                    @change="onTimeSelectB"
                    @blur="onTimeSelectB"
                  />
                  <div class="c-error c-error--balloon c-error--time">
                    <div class="c-error__text"></div>
                  </div>
                </div>
                <!-- <select-text
                                    :value="messageB.message_deliver.deliver_type == 1 ? messageB.message_deliver.send_start_date.substring(11,16) : ''"
                                    ref="timeSelect"
                                    :classes="['u-w220']"
                                    place-holder="時間設定"
                                    :elements="times"
                                    @select="onTimeSelectB"
                                    input-name="delivery_hour_b"
                                >
                                </select-text> -->
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict p-message-predict--no-number">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onQuitClick"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingSaveBtn }"
              :disabled="isLoadingSaveBtn"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <div class="p-message-predict__btns">
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingNextBtn }"
            :disabled="isLoadingNextBtn"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">確認画面へ</p>
          </button>
        </div>
      </div>
    </div>

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
import Datepicker from '../molecules/Datepicker.vue';
const ja = 'ja';
import axios from 'axios';
import moment from 'moment';
import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'

export default {
  components: {
    'datepicker': Datepicker,
    'timepicker': VueTimepicker,
  },
  props: {
    csrfToken: String,
    breadcrumbData: Array,
    abtest: Object,
    abtestTypeValues: Object,
    linkData: Object,
  },
  data () {
    return {
      ja:ja,
      requireInteraction: null,
      sendStartDateA: null,
      sendStartTimeA: null,
      sendStartDateB: null,
      sendStartTimeB: null,
      errorMessage: '',
      isError: false,
      isLoadingNextBtn: false,
      isLoadingSaveBtn: false,
      highlightedDates: {
        customPredictor: (date) => {
          const today = new Date();
          const targetDate = new Date(date);
          return (
            today.getFullYear() === targetDate.getFullYear() &&
            today.getMonth() === targetDate.getMonth() &&
            today.getDate() === targetDate.getDate()
          );
        },
        color: '#209bb9'
      },
      disableDateTimePicker: false,
    }
  },
  computed: {
    messageA: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 0) {
        message = this.abtest.abtest_messages[0].message;
      }
      return message;
    },
    messageB: function () {
      let message = null;
      if (this.abtest && this.abtest.abtest_messages.length > 1) {
        message = this.abtest.abtest_messages[1].message;
      }
      return message;
    },
  },
  mounted: function() {
    import('../../funcs/pages/abtest-message-add').then(module => {
      module.AbtestMessageAdd();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });
    let messageA = this.messageA;
    let messageB = this.messageB;
    this.requireInteraction = messageA.require_interaction;
    if(messageA.message_deliver.deliver_type == 1 && messageA.message_deliver.send_start_date){
      this.sendStartDateA = messageA.message_deliver.send_start_date.substring(0,10);
      this.sendStartTimeA = messageA.message_deliver.send_start_date.substring(11,16);
    } else {
      this.sendStartDateA = null;
      this.sendStartTimeA = '';
    }
    if(messageB.message_deliver.deliver_type == 1 && messageB.message_deliver.send_start_date){
      this.sendStartDateB = messageB.message_deliver.send_start_date.substring(0,10);
      this.sendStartTimeB = messageB.message_deliver.send_start_date.substring(11,16);
    } else {
      this.sendStartDateB = null;
      this.sendStartTimeB = '';
    }
    if(messageA.deliver_status == 30) {
      this.disableDateTimePicker = true;
    }
  },
  methods: {
    showCalendar: function(name) {
      const list = {
        delivery_date_a: 'refSendStartDateA',
        delivery_date_b: 'refSendStartDateB',

      };
      Object.keys(list).forEach((key, _index) => {
        if (!this.$refs[list[key]]) return;
        if (name == key) {
          this.$refs[list[key]].$el.querySelector('input').focus();
          this.$refs[list[key]].showCalendar();
        } else {
          this.$refs[list[key]].close(true);
        }
      })
    },
    onSaveClick: function() {
      this.isLoadingSaveBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.listUrl,false);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingSaveBtn = false; }, 300);
      }
    },
    onQuitClick: function() {
      location.href = this.linkData.listUrl;
    },
    onNextClick: function(event) {
      event.preventDefault();
      this.isLoadingNextBtn = true;

      if(this.validate()){
        this.saveAbtest(this.linkData.confirmUrl,true);
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください'
        setTimeout(() => { this.isLoadingNextBtn = false; }, 300);
      }
    },
    saveAbtest: function(completeUrl,hasArgument) {
      //*
      let sendStartDateA = moment(this.sendStartDateA).format('YYYY-MM-DD') + ' ' + this.sendStartTimeA + ':00';
      let sendStartDateB = moment(this.sendStartDateB).format('YYYY-MM-DD') + ' ' + this.sendStartTimeB + ':00';

      let params = new FormData();
      this.appendForm(params,'abtest_id',this.abtest.abtest_id);
      this.appendForm(params,'require_interaction',this.requireInteraction);
      this.appendForm(params,'send_start_date_a',sendStartDateA);
      this.appendForm(params,'send_start_date_b',sendStartDateB);

      axios.post('/api/abtest/save-timezone',params)
        .then(res => {
          if(this.handleResponse(res)){
            let url = completeUrl;
            if(hasArgument){
              url += '?abtest_id=' + res.data.abtest_id;
            }
            location.href = url;
          } else {
            this.isError = true;
            this.errorMessage = 'メッセージの保存に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
            this.isLoadingNextBtn = false;
          }, 300);
        });
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    validate: function() {
      let isValid = true;
      let errors = {};

      if(!this.sendStartDateA){
        errors['send_start_date_a'] = '日付を入力してください';
      }
      if(!this.timeIsValid(this.sendStartTimeA)){
        errors['delivery_hour_a'] = '時間を選択してください';
      }

      let sendStartDateA = moment(this.sendStartDateA).format('YYYY-MM-DD') + ' ' + this.sendStartTimeA + ':00';
      if (moment(sendStartDateA) < moment() && !errors['send_start_date_a'] && !this.disableDateTimePicker) {
        errors['send_start_date_a'] = '過去の時間が指定されています';
      }

      if(!this.sendStartDateB){
        errors['send_start_date_b'] = '日付を入力してください';
      }
      if(!this.timeIsValid(this.sendStartTimeB)){
        errors['delivery_hour_b'] = '時間を選択してください';
      }

      let sendStartDateB = moment(this.sendStartDateB).format('YYYY-MM-DD') + ' ' + this.sendStartTimeB + ':00';
      if (moment(sendStartDateB) < moment() && !errors['send_start_date_b']) {
        errors['send_start_date_b'] = '過去の時間が指定されています';
      }

      if(Object.keys(errors).length > 0){
        this.showErrors(errors);
        isValid = false;
      }

      return isValid;
    },
    onTimeSelectA: function(selected) {
      if (selected && selected.data && selected.data.HH != '') {
        if (selected.data.mm == '') {
          selected.data.mm = '00'
        }
        this.sendStartTimeA = `${selected.data.HH}:${selected.data.mm}`;
      }
    },
    onTimeSelectB: function(selected) {
      if (selected && selected.data && selected.data.HH != '') {
        if (selected.data.mm == '') {
          selected.data.mm = '00'
        }
        this.sendStartTimeB = `${selected.data.HH}:${selected.data.mm}`;
      }
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  }
}
</script>

<style>
input[name="delivery_date_a"]:disabled {
  color: #d2d2d2;
}
.default-cursol {
    cursor: auto;
}
</style>
